export const BASE_URL = process.env.REACT_APP_SOMS_BASE_URL;
export const BASE_URL_ROUTE53 = process.env.REACT_APP_SOMS_ROUTE53_URL;
export const SOS_BASE_URL = process.env.REACT_APP_SOS_BASE_URL;
export const SOMS_API_KEY = process.env.REACT_APP_SOMS_API_KEY;
export const BASE_URL_TOKEN = process.env.REACT_APP_API_TOKEN;
export const BASE_URL_USERS = process.env.REACT_APP_API_ENDPOINT;
export const SUPPLIER_V1_URL = process.env.REACT_APP_SOMS_SUPPLIER_V1_URL;
export const USERS_ENDPOINT = "users/@all/countschedules"; 
export const USERS_PREVILEGE_ENDPOINT = "users/"; 
export const GET_ROLES_ENDPOINT = "roles";
export const GET_STORE_CATALOGUE = "productdetails";
export const ORDER_OPPORTUNITIES_ENDPOINT = "orderopportunities/@lookup"; 
export const API_KEY = process.env.REACT_APP_API_KEY;
export const AUTH = process.env.REACT_APP_AUTH;
export const SEARCH_PO_ENDPOINT = "manualporequests/@fetchorders";
export const SEARCH_SUPPLIER_ENDPOINT = "search";
export const SEARCH_ORDEROPPORTUNITIES_ENDPOINT = "manualporequests/@searchorderopportunities";
export const UPLOAD_MANUAL_PURCHASE_ORDER_ENDPOINT  = "manualporequests/@uploadmanualpo";
export const AMEND_PURCHASE_ORDER_ENDPOINT = "manualporequests";
export const DO_NOT_ORDER_LIST_ENDPOINT = "restricteditems";
export const SUPPLIER_DESTINATION_MAPPING_ENDPOINT = "sourcedestinationmapping";

export const GET_AMEND_REASONS = "";
export const GET_LOCATION_ID = "locations";
export const GET_DEPOT_ID = "locations";
export const GET_STORE_ID = "";
export const POST_DOWNLOAD_CUSTOMER_DEMANDS_REPORT = "@downloaddemands";
export const POST_FILE_ACCESS = "fileaccess";
export const POST_AMENDMENT_REPORT = "@uploaddemands";


export const SYSTEM_ERROR = "System error. Please try again later!";
export const DEPOTID_NOT_FOUND = "Depot Id not found";
export const STOREID_NOT_FOUND = "Store Id not found";
export const NETWORK_ERROR = "Unable to connect to the server. Please check your internet connection and try again.";
export const UPLOAD_FAILED = "Failed to upload file to Amend/Cancel Third-party Customer Orders.";
export const UPLOAD_SUCCESS = "The file uploaded successfully to Amend/Cancel Third-party Customer Orders.";
export const DOWNLOAD_FAILED = "Failed to download file. Please try again later!";
export const DOWNLOAD_SUCCESS = "File downloaded successfully.";
export const CORRECT_VALUE_SELECTION = "Please enter proper values.";
export const CORRECT_FILE_SELECTION = "Please select a valid file.";
export const VALIDATE_SUCCESS = "The emergency orders submitted successfully.";
export const VALIDATE1_SUCCESS = "The Emergency Orders submitted successfully";
export const EMERGENCY_ORDER_DOWNLOAD_SUCCESS  = "Emergency orders lifecycle report file downloaded successfully"
export const CORRECT_VALUE_SELECTION_EMERGENCYORDER = "Item not found. Please refine your search criteria.";
export const UPLOAD_FAILED_EMERGENCYORDER = "Failed to upload the file.";
export const SAVED_SUCCESS = "Data saved successfully!";
export const D1D2ConfigurationTime = "11:30 AM to 5:30 PM";
export const BULK_UPLOAD_FILE_SIZE = "File size exceeds 50MB. Please upload a smaller file.";
export const BULK_UPLOAD_COLUMN_COUNT_ERROR = "Incorrect file format, please check column sequence, column data and upload file with correct template.";
export const UPLOAD_RECEIPT_FILE_ENDPOINT = "manualporequests/@uploadporeceipt";
export const RECEIPT_FILE_SIZE_EXCEEDED = "File size exceeds 10MB. Please upload a smaller file.";
export const FEATURE_SETTINGS_DOWNLOAD_ENDPOINT = "featuresettings/@download";
export const FEATURE_SETTINGS_ENDPOINT = "featuresettings";
export const MAX_CAP_OFFSET = 0;
export const MAX_CAP_LIMIT = 100;
export const MAX_CAP_QTY_TYPE = "CS";
export const MAX_CAP_STATUS = "active";
export const MAX_CAP_FEATURE = "maxOrderQuantity";
export const MAX_CAP_FORMAT_CSV = "csv";
export const MAX_CAP_ADD_SUCCESS = "Item added successfully.";
export const MAX_CAP_UPDATE_SUCCESS = "Item updated successfully.";
export const MAX_CAP_DELETE_SUCCESS = "Deleted successfully.";
export const MAX_CAP_BULK_UPDATE_TITLE = "Update PIN Max Cap Configuration for all stores";
export const MAX_CAP_ADD_NEW_PIN_TITLE = "Add New PIN to Max Cap Configuration";
export const MAX_CAP_DELETE_PIN_TITLE = "Delete PIN Max Cap Configuration";
export const MAX_CAP_SELECTION_LIMIT_MSG = "Maximum selection of 200 rows is allowed.";
export const MAX_CAP_UPDATE_FAILED_MSG = "Failed to update.";
export const DOWNLOAD_SUCCESFULL = "Download Successful";
export const MAXCAP_SUCCESS_DOWNLOAD_EXTRACT = "Max Cap report downloaded successfully.";
export const MAXCAP_FAILED_DOWNLOAD_EXTRACT = "Failed to download report. Please try again later!";
export const FILE_DOWNLOAD_LOADING_MESSAGE = "To ensure the successful download, please avoid clicking the back button, leaving the page, or refreshing it during the download process"
